import { useCallback, useEffect, useState } from 'react';
import api from './api';
import { mapApiCourse } from './courses';

const cache = new Map();

export const cacheCourses = (apiList) => (apiList || []).forEach(c => cache.set(c.id, mapApiCourse(c)));

const initial = (id) => {
  const hit = cache.get(id);
  return { id, course: hit || null, status: hit ? 'ready' : 'loading' };
};

export const useCourse = (id, userKey) => {
  const [state, setState] = useState(() => initial(id));
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    let alive = true;
    setState(s => (s.id === id && s.course ? s : initial(id)));
    api.get(`/courses/${id}`)
      .then(({ data }) => {
        const course = mapApiCourse(data);
        cache.set(id, course);
        if (alive) setState({ id, course, status: 'ready' });
      })
      .catch((err) => {
        if (!alive) return;
        if (err?.response?.status === 404) { cache.delete(id); setState({ id, course: null, status: 'notfound' }); }
        else setState(s => (s.id === id && s.course ? s : { id, course: null, status: 'error' }));
      });
    return () => { alive = false; };
  }, [id, userKey, nonce]);

  const retry = useCallback(() => { setState(initial(id)); setNonce(n => n + 1); }, [id]);
  const current = state.id === id ? state : initial(id);
  return { course: current.course, status: current.status, retry };
};
